import { Database } from './../database';
import { Injectable } from "@angular/core";

import 'rxjs/add/operator/map';

@Injectable()
export class BllBirimler extends Database{
    eklenecek_birimler=[];

    constructor(){
        super("NL_Birim");
    }
}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-birimler.ts